module.exports = __webpack_public_path__ + "static/word-health.b418bda8.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/word-health.png
// module id = 992
// module chunks = 2